<template>
    <v-container fluid>
        <v-col :alvqa="alvqa + '-title'">
            <v-row class="pl-4 headline">
                {{ item.fileName }}
                ({{ $t('lang_GENERAL_CAPTION_NUMBER_OF_ERRORS') }}: {{ item.numberOfTotalRows }})
            </v-row>
        </v-col>

        <v-row class="pl-4 pr-4">
            <v-col>
                <v-data-table
                    :headers="headers"
                    hide-default-footer
                    :items="item.list"
                    :no-data-text="$t('lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')"
                    style="background-color: var(--v-expandPanelBackground-base);"
                    class="noMinWidth"
                    :header-props="{ sortIcon: '' }"
                    :items-per-page="itemsPerPage"
                >
                    <!-- alvqas for headers -->
                    <template v-for="(header, i) in headers" v-slot:[`header.${header.value}`]>
                        <span :alvqa="header.alvqa" :key="i">{{ header.text }}</span>
                    </template>

                    <!-- cell content -->
                    <template v-slot:[`item.title`]="{ item }">
                        <div class="ellipsis">
                           <BaseTooltip 
                                :simpleText="item.title +' (' + $t('lang_PUBLISHING_INCOME_CAPTION_ERRORS') + ': '+ item.numberOfRows +')'"
                                :alvqa="alvqa + '-error-list-text-track-releases-title'"
                           />
                        </div>
                    </template>
                    <template v-slot:[`item.artist`]="{ item }">
                        <div class="ellipsis">
                           <BaseTooltip 
                                :simpleText="item.artist"
                                :alvqa="alvqa + '-error-list-text-artist'"
                           />
                        </div>
                    </template>
                    <template v-slot:[`item.isrc`]="{ item }">
                        <div :alvqa="alvqa + '-error-list-text-isrc'">
                            {{ item.isrc }}
                        </div>
                    </template>
                    <template v-slot:[`item.catalogueNo`]="{ item }">
                        <div :alvqa="alvqa + '-error-list-text-catalogue-number'" class="ellipsis">
                           <BaseTooltip 
                                :simpleText="item.catalogueNo"
                                :alvqa="alvqa + '-error-list-text-catalogue-number'"
                           />
                        </div>
                    </template>
                    <template v-slot:[`item.ean`]="{ item }">
                        <div :alvqa="alvqa + '-error-list-text-upc-ean'">
                            {{ item.ean }}
                        </div>
                    </template>
                    <template v-slot:[`item.salesType`]="{ item }">
                        <div :alvqa="alvqa + '-error-list-text-sales-type'">
                            {{ item.salesType }}
                        </div>
                    </template>
                    <!-- <template v-slot:[`item.errorType`]="{ item }">
                        <div :alvqa="alvqa + '-error-list-text-error-type'">
                            {{ item.errorType }}
                        </div>
                    </template> -->
                    <template v-slot:[`item.error`]="{ item }">
                        <div :alvqa="alvqa + '-error-list-text-description'">
                            {{ item.error }}
                        </div>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import BaseTooltip from '@/components/_base/BaseTooltip'

export default {
    name: "SalesDataReadOnly",
    components: {
        BaseTooltip
    },
    props: {
        itemId: Number
    },
    data() {
        return {
            alvqa: "label-salesdata-list-row-" + this.itemId + '-read-only'
        }
    },
    computed: {
        item() {
            return this.$store.getters.getExpandedSalesData.find(element => {
                return element.id === this.itemId
            })
        },
        headers() {
            return [
                {
                    text: this.$t("lang_LABEL_SALES_DATA_CAPTION_TRACK_ALBUM_NAME"),
                    value: "title", 
                    align: "left", 
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + "-error-list-header-track-releases-title"
                },
                {
                    text: this.$t("lang_LABEL_SALES_DATA_CAPTION_ARTIST"),
                    value: "artist", 
                    align: "left", 
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + "-error-list-header-artist"
                },
                {
                    text: this.$t("lang_LABEL_TRACKS_CAPTION_ISRC"),
                    value: "isrc", 
                    align: "left", 
                    class: 'text-no-wrap',
                    width: '150px',
                    sortable: false,
                    alvqa: this.alvqa + "-error-list-header-isrc"
                },
                {
                    text: this.$t("lang_LABEL_SALES_DATA_CAPTION_CAT_NO"),
                    value: "catalogueNo", 
                    align: "left", 
                    class: 'text-no-wrap',
                    width: '120px',
                    sortable: false,
                    alvqa: this.alvqa + "-error-list-header-catalogue-number"
                },
                {
                    text: this.$t("lang_LABEL_SALES_DATA_CAPTION_UPC_EAN"),
                    value: "ean", 
                    align: "left", 
                    class: 'text-no-wrap',
                    width: '150px',
                    sortable: false,
                    alvqa: this.alvqa + "-error-list-header-upc-ean"
                },
                {
                    text: this.$t("lang_LABEL_SALES_DATA_CAPTION_SALES_TYPE"),
                    value: "salesType", 
                    align: "left", 
                    class: 'text-no-wrap',
                    width: '150px',
                    sortable: false,
                    alvqa: this.alvqa + "-error-list-header-sales-type"
                },
                // {
                //     text: this.$t("lang_LABEL_SALES_DATA_CAPTION_ERROR"),
                //     value: "errorType", 
                //     align: "left", 
                //     class: 'text-no-wrap',
                //     width: '100px',
                //     alvqa: this.alvqa + "-error-list-header-error-type"
                // },
                {
                    text: this.$t("lang_LABEL_SALES_DATA_CAPTION_ERROR_DESCRIPTION"),
                    value: "error", 
                    align: "left", 
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + "-error-list-header-error-description"
                },
            ]
        },

        itemsPerPage() { return this.$store.getters.getItemsPerPage },
    }
}
</script>

<style>
    .noMinWidth table {
        min-width: 0px !important;
        table-layout: fixed;
    }
</style>